import { useTranslation } from "react-i18next";
import getImageSrc from "src/utils/getImageSrc";
import VerticalDialog from "src/components/VerticalDialog";

export default function ConnectionLostDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  return (
    <VerticalDialog
      buttonBottom={{
        text: t("buttons.cancel"),
        onClick: onDismiss
      }}
      imageSrc={getImageSrc("connection-lost.svg")}
      heading={t("connectionLost.heading")}
      text={t("messages.reconnecting")}
      isOpen={isOpen}
      zIndex={101}
    />
  );
}
